function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.925 1.625l-5.3 5.3a.25.25 0 01-.355 0L.575 4.23a.25.25 0 010-.355l.35-.35a.25.25 0 01.355 0L3.445 5.69 8.22.915a.255.255 0 01.355 0l.35.355a.25.25 0 010 .355z"
});

var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 7"
  }, props), _ref);
};

export default SvgCheckmark;